import { client } from '@global/Api';
import { INTROSPECT } from '@global/requests/auth';
import { IntrospectInfo, IntrospectResponse } from './types';

export const introspectToken = async (
  accessToken: string,
  ecomToken?: string,
  idToken?: string
): Promise<IntrospectInfo> => {
  try {
    const { data } = await client.query<IntrospectResponse>({
      query: INTROSPECT,
      variables: { token: accessToken, ecomToken, idToken },
    });

    return data.wEcomIntrospect.result.data;
  } catch (err) {
    console.error(err);
    return { tokenIsValid: false, ecomToken: '' };
  }
};
